module.exports = __webpack_public_path__ + "static/media/NonWord-Intro-AFTER-trail-exercises.5e7d4730.mp3";